import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, AfterViewInit, PLATFORM_ID, Inject} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
@Component({
  selector: 'component-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.css', '../../../styles.scss']
})
export class TestimonialsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('testimonialsCarousel') testimonialsCarousel!:ElementRef;
  testimonial_carousel_options: OwlOptions = {
    
    autoplayTimeout:2350,
    autoplayHoverPause:true,
    autoplayMouseleaveTimeout:1000,
    loop: true,
    margin: 30,
    stagePadding: 55,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    freeDrag:true,
    dots: true,
    navSpeed: 700,
    nav: false,
    navText: ['<div class="custom-arrow"> <img width="12" height="18" src="assets/icons/back_semi_arrow.png" alt="'+$localize`Icono de retroceso`+'"> </div>',
      '<div class="custom-arrow" ><img width="12" height="18" src="assets/icons/forward_semi_arrow.png" alt="'+$localize`Icono de avance`+'"> </div>'],
    responsive: {
      300: {
        items: 1
      },
      400: {
        items: 1
      },
      540: {
        items: 1.5
      },
      600: {
        items: 2
      },
      800: {
        items: 2.5
      },
      940: {
        items: 2.5
      },
      1600: {
        items: 3.5
      }
    }
  };
  testimonials: Array<any> = [
    {
      author: `S.B`,
      age: `29`,
      topic: $localize`ADICCIÓN`,
      testimonial: $localize`<p>"La forma en que este tratamiento te quita la ansiedad de adicción es impresionante. Llevaba 15 años sin poder
      dejar el cigarro y el alcohol, sí había tenido momentos donde le bajaba pero la realidad es que siempre regresaba
      a tomar teniendo un ciclo repetitivo que no tenía fin.\n
      El tratamiento logró que pudiera dejarlo por completo. Ahora pude salir y pasarla super bien sin tener esa
      ansiedad de tomar, el tratamiento fue ese pequeño empujón que necesitaba para realmente no volver a caer.
      Gracias gracias gracias por ayudarme a lograr lo que nada más me había logrado ayudar desde hace 15 años."</p>`
    },
    {
      author: `R.H.`,
      age: `34`,
      topic: $localize`Dejar los antidepresivos`,
      testimonial: $localize`<p>"El tratamiento me ayudó a dejar los antidepresivos que llevaba tomando 24 años, ha sido increíble
      especialmente porque siempre me habían dicho que era algo que no iba a poder hacer. Llevo 3 meses
      sin tomar nada."</p>`,
    },
    {
      author: `L.E.`,
      age: `41`,
      topic: $localize`Depresión y Ansiedad`,
      testimonial: $localize`<p>"Quiero darles las gracias, no pueden imaginar lo bien que me siento. Tengo ganas de bailar y cantar
      todo el día. La ansiedad se ha ido. Perdí gemelos hace 6 años y desde entonces había estado
      viviendo en modo de supervivencia"</p>`,
    },
    {
      author: `E.S.`,
      age: ``,
      topic: $localize`Psicoterapeuta`,
      testimonial: $localize`<p>"Llegaron a trabajar conmigo en psicoterapia dos pacientes que están trabajando con micro dosis y para mí ha
      sido una grata sorpresa porque me estoy dando cuenta que tiene mayor capacidad de observación, la
      posibilidad de auto-observación e “insights” es mucho más grande y sobretodo corporalmente están teniendo
      mayor integración más rápido de lo normal.\n
      Entran mucho más profundo en los procesos de Psicoterapia y tienen una capacidad de darse cuenta a
      diferentes niveles. Me gusta el trabajo que están realizando!"</p>`,
    },
    {
      author: `H.O.`,
      age: `36`,
      topic: $localize`Migraña`,
      testimonial: $localize`<p>"En mi vida he tenido cefalea en racimos o “cluster headache”. Un amigo me recomendó agregar micro
      dosis a mi dieta y me ayudó mucho a tratar el dolor. Usar la medicina de manera regular
      durante un cluster con una dosis de .2 en ayuno me ayudó a cortar el ciclo y disminuir el dolor y
      constancia de los ataques. Lo recomiendo ampliamente como suplemento; lo tomé durante 6 semanas y
      no he tenido un ataque en 18 meses."</p>`,
    },
  ];
  scrollTimeout!: ReturnType< typeof setTimeout>;
  constructor(@Inject(PLATFORM_ID) private platformId: Object,@Inject(DOCUMENT) private document:Document) {
  }
  
  carouselScroll(event:any){
    clearTimeout(this.scrollTimeout);
    let nextOwl:any = this.document.getElementsByClassName('owl-next')[0];
    let prevOwl:any = this.document.getElementsByClassName('owl-prev')[0];
    let deltaY = event.deltaY;
    let deltaX = event.deltaX;

    this.scrollTimeout = setTimeout(() => {
       if(!event.shiftKey)return;
      // switch (event.shiftKey == true) {
      //   case deltaY<0:
      //   case deltaX<0:
      //     prevOwl.click();
      //     break;
      //   case deltaX>0:
      //   default:
      //     nextOwl.click();
      //     break;
      // }
      if (deltaY<0 || deltaX<0) {
        prevOwl.click();
      } else {
        nextOwl.click();
      }
    }, 80);
    
    
  }
  carouselObserver!:IntersectionObserver;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.carouselObserver = new IntersectionObserver(
        (entries)=>{
          if (entries[0].intersectionRatio>.6) {
            this.testimonial_carousel_options.autoplay = true;
          }else{
            this.testimonial_carousel_options.autoplay = false;
          }
        },
        {threshold:[0,.3,.6,1]}
      );
    }
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.carouselObserver.observe(this.testimonialsCarousel.nativeElement) 
    }
  }

  
  ngOnDestroy(): void {
    if (this.carouselObserver){
      this.carouselObserver.disconnect();
    }
  }
}
